<template>
  <div class="index container">
    <transition name="fade">
      <router-view @showParent="showParent"> </router-view>
    </transition>

    <div v-if="showParentPage">
      <v-breadcrumbs>
        <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
          >Home</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item
          :exact="true"
          :to="{ name: 'role', params: {} }"
          active
        >
          Role
        </v-breadcrumbs-item>
      </v-breadcrumbs>

      <div class="d-flex flex-column flex-lg-row">
        <v-text-field
          dense
          v-model="searchTerms"
          @keyup.enter="search"
          @click:clear="clearSearch"
          @click:append="search"
          placeholder="Press enter to begin search"
          append-icon="mdi-magnify"
          outlined
          clearable
          label="Search"
        />
        <v-btn
          class="ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start"
          color="primary"
          :to="{ name: 'roleCreate', params: {} }"
        >
          Create Role
        </v-btn>
      </div>
      <v-divider class="mb-4" />
      <div class="table-container">
        <v-select
          label="Filter by Modules"
          v-model="filterModule"
          :items="modules"
          item-value="id"
          item-text="name"
          clearable
          @change="search"
        />
        <v-data-table
          :headers="headers"
          :items="roleList"
          :items-per-page="pagination.pageSize"
          :loading="!roleProcessed"
          :server-items-length="pagination.totalSize"
          :page="pagination.current"
          :disable-pagination="!roleList || roleList.length < 1"
          :hide-default-header="!roleList || roleList.length < 1"
          :hide-default-footer="!roleList || roleList.length < 1"
          :options.sync="options"
          item-key="id"
          class="elevation-1"
          @update:options="pageChanged"
        >
          <template v-slot:item.moduleId="{ item }">
            <a @click="edit(item)">
              {{ item.moduleId ? item.moduleName : "All Modules" }}
            </a>
          </template>

          <template v-slot:item.name="{ item }">
            <a @click="view(item)">{{ item.name }}</a>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="edit(item)"> mdi-pencil </v-icon>
            <v-icon small class="mr-2" @click="remove(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </div>
    </div>
    <confirmation-dialog ref="confirm" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");
import { getAccountModules } from "@/services/module";

export default {
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100,
      },
      options: {
        //define default sorting option here.
        sortBy: [],
        sortDesc: [],
      },
      roleList: [],
      showParentPage: true,

      headers: [
        {
          text: "Module",
          value: "moduleId",
          align: "start",
          sortable: true,
        },
        {
          text: "Role",
          value: "role",
          align: "start",
          sortable: true,
        },
        {
          text: "Name",
          value: "name",
          align: "start",
          sortable: false,
        },

        { text: "Actions", value: "actions", align: "end", sortable: false },
      ],
      sort: {
        key: null,
      },
      searchTerms: "",
      modules: [],
    };
  },
  components: {
    ConfirmationDialog,
  },
  computed: {
    ...mapGetters("role", ["roleProcessed", "getRoles"]),
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),
    ...mapActions("role", ["deleteRole", "fetchRoles"]),
    view(item) {
      this.$router.push({ name: "roleView", params: { id: item.id } });
    },
    edit(item) {
      this.$router.push({ name: "roleEdit", params: { id: item.id } });
    },
    async remove(item) {
      let confirm = await this.$refs.confirm.open(
        "Confirm Delete",
        "Do you want to delete this role?"
      );
      if (confirm) {
        this.deleteRole(item.id)
          .then(() => {
            this.addSuccessMessage("role was deleted with successfull!");
            this.getResources();
          })
          .catch(() => {
            this.addErrorMessage("Server response with error ");
          });
      }
    },
    async getResources() {
      this.modules = await getAccountModules().then((resp) => {
        return resp.data.content;
      });

      //default to sorting by ID desc if not defined
      const sortBy =
        this.options["sortBy"] && this.options["sortBy"].length > 0
          ? this.options.sortBy[0]
          : "id";
      const sortDesc =
        this.options["sortDesc"] && this.options["sortDesc"].length > 0
          ? this.options.sortDesc[0]
          : true;
      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
        size: this.pagination.pageSize,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
        moduleId: this.filterModule,
      };
      if (this.searchTerms) {
        params["name"] = this.searchTerms;
      }

      this.fetchRoles(params)
        .then((response) => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.roleList = response.content;

            this.roleList.forEach(r => {
              const module = this.modules.find(m => m.id == r.moduleId)
              if(module){
                r.moduleName = module.name;
              }
            })
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    showParent(show) {
      this.showParentPage = show;
    },
    pageChanged(pagination) {
      this.pagination.pageIndex = pagination.page;
      this.pagination.pageSize = pagination.itemsPerPage;

      this.getResources();
    },
    search() {
      this.getResources();
    },
    clearSearch() {
      this.searchTerms = null;
      this.getResources();
    },
  },
  watch: {
    "pagination.numberRegisterForPage": function () {
      this.pagination.current = -1;
    },
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.showParentPage = toDepth < fromDepth;
    if (this.showParentPage) {
      this.getResources();
    }
    next();
  },
};
</script>
